/**
 * Strips keys whose value is `undefined` from a shallow object.
 *
 * Firestore rejects documents that contain explicit `undefined` values
 * (throws "Unsupported field value: undefined"). This utility produces a
 * clean copy safe for `setDoc` / `updateDoc` / `batch.set`.
 *
 * Only performs a shallow strip — nested objects are left as-is. This is
 * sufficient for our flat Firestore document shapes (Human, HumanRelationship).
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function stripUndefinedFields<T extends Record<string, any>>(obj: T): T {
  const result: Record<string, any> = {};
  for (const [key, value] of Object.entries(obj)) {
    if (value !== undefined) {
      result[key] = value;
    }
  }
  return result as T;
}
